<template>
  <div>
    <b>General description</b>
    <br />
    This mission allows to modify the mean anomaly of the spacecraft on its
    orbit by the specified amount ΔAOL. This means that at the end of the
    manoeuvre the angular separation with respect to an unperturbed satellite
    following the initial orbit will equal ΔAOL. The manoeuvre needed to achieve
    this configuration exploits the variation in the spacecraft's angular
    velocity with semi-major axis. No perturbations are taken into account for
    the computation of this manoeuvre.
    <br />
    A typical scenario is the post-injection deployment of a 2-spacecraft
    constellation on a single plane. The spacecrafts are injected at the same
    point and need to reach the operational configuration, where they are
    separated by ΔAOL = 180 deg.
    <br />
    <br />
    This manoeuvre consists of the following distinct phases:
    <br />
    - A first tangential thrust brings the spacecraft from the initial
    user-specified orbit to the drift altitude.
    <br />
    - A coasting phase (no firing of the propulsion systems) at drift altitude
    <br />
    - A final manoeuvre to bring the satellite back to the initial altitude, at
    desired location.
    <br />
    <br />
    The velocity increment ΔV to perform the two manoeuvres are computed using
    analytical formulas.
    <br />
    The drift altitude is computed using an iterative numerical root-finding
    method.
    <br />
    <br />
    <b>Example</b>
    Let's consider a spacecraft into a 600km SSO which needs to perform a
    rendez-vous with another spacecraft located on the same orbit but with an
    angular separation of 10 degrees. The following figure (generated using the
    "Simulation Orbit Phasing" mission) shows the manoeuvre needed in order to
    perform the aforementioned manoeuvre.
    <br />
    <br />
    <v-img
      contain
      :src="require('../../assets/images/description-orbit-phasing.png')"
      aspect-ratio="1.8"
    />
    <br />
    <br />
  </div>
</template>

<script>
export default {
  name: 'tooltipParametricOrbitPhasing'
}
</script>
